// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  RegattaResultTableRaceType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvForm,
  AvInput,
} from 'availity-reactstrap-validation';

// Types
import type {
  $TileResult,
} from '../../../types';

type $Props = $Translate & {
  item: $Model<'RegattaResultTableRaceResult'> | $TileResult;
  onChange: (arg0: $Model<'RegattaResultTableRaceResult'> | $TileResult) => unknown;
  raceType: RegattaResultTableRaceType;
};

const showValue = (
  value?: null | number,
): string => (value !== null ? String(value) : '');

const validateValue = (
  value: null | string,
  min: number,
  max: number,
): boolean => {
  if (value === '') {
    return true;
  }

  const numberValue: number = Number(value);

  if (numberValue >= min && numberValue <= max) {
    return true;
  }

  return false;
};

class InputResultView extends React.Component<$Props> {
  updateValue(
    p: 'Day' | 'Hour' | 'Minute' | 'Month' | 'Second',
    value: null | string,
    min: number,
    max: number,
  ): void {
    const {
      item,
      onChange,
    } = this.props;

    if (validateValue(
      value,
      min,
      max,
    ) === true) {
      const itemToUpdate = item;

      itemToUpdate[p] = value === '' ? null : Number(value);

      onChange(itemToUpdate);
    }
  }

  renderTimeInputs() {
    const {
      item,
    } = this.props;

    return (
      <Row className={'no-gutters'}>
        <Col>
          <AvInput
            className={'p-0 text-center'}
            name={'Month'}
            onBlur={(e) => this.updateValue(
              'Month',
              e.target.value,
              1,
              12,
            )}
            placeholder={'M'}
            validate={{
              async: async (v) => validateValue(
                v,
                1,
                12,
              ),
            }}
            value={showValue(item.Month)}
          />
        </Col>
        <Col>
          <AvInput
            className={'p-0 text-center'}
            name={'Day'}
            onBlur={(e) => this.updateValue(
              'Day',
              e.target.value,
              1,
              31,
            )}
            placeholder={'D'}
            validate={{
              async: async (v) => validateValue(
                v,
                1,
                31,
              ),
            }}
            value={showValue(item.Day)}
          />
        </Col>
        <Col>
          <AvInput
            className={'p-0 text-center'}
            name={'Hour'}
            onBlur={(e) => this.updateValue(
              'Hour',
              e.target.value,
              0,
              23,
            )}
            placeholder={'H'}
            validate={{
              async: async (v) => validateValue(
                v,
                0,
                23,
              ),
            }}
            value={showValue(item.Hour)}
          />
        </Col>
        <Col>
          <AvInput
            className={'p-0 text-center'}
            name={'Minute'}
            onBlur={(e) => this.updateValue(
              'Minute',
              e.target.value,
              0,
              59,
            )}
            placeholder={'M'}
            validate={{
              async: async (v) => validateValue(
                v,
                0,
                59,
              ),
            }}
            value={showValue(item.Minute)}
          />
        </Col>
        <Col>
          <AvInput
            className={'p-0 text-center'}
            name={'Second'}
            onBlur={(e) => this.updateValue(
              'Second',
              e.target.value,
              0,
              59,
            )}
            placeholder={'S'}
            validate={{
              async: async (v) => validateValue(
                v,
                0,
                59,
              ),
            }}
            value={showValue(item.Second)}
          />
        </Col>
      </Row>
    );
  }

  renderRoundings() {
    const {
      item,
      t,
    } = this.props;

    return (
      <AvInput
        className={'py-0 text-center'}
        name={'Second'}
        onBlur={(e) => this.updateValue(
          'Second',
          e.target.value,
          0,
          1000,
        )}
        placeholder={t('Roundings')}
        type={'number'}
        validate={{
          async: async (v) => validateValue(
            v,
            0,
            1000,
          ),
        }}
        value={showValue(item.Second)}
      />
    );
  }

  render() {
    const {
      item,
      onChange,
      raceType,
    } = this.props;

    return (
      <AvForm>
        <Row className={'no-gutters'}>
          <Col xs={3}>
            <AvInput
              className={'p-0 text-center'}
              name={'Position'}
              onBlur={(e) => onChange({
                ...item,
                Position: e.target.value === '' ? null : e.target.value,
              })}
              placeholder={'POS'}
              value={item.Position}
            />
          </Col>
          <Col xs={9}>
            {raceType === RegattaResultTableRaceType.roundings
              ? this.renderRoundings()
              : this.renderTimeInputs()}
          </Col>
        </Row>
      </AvForm>
    );
  }
}

export default InputResultView;
